type ConfigFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
};

type ConfigFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  orElse: () => R;
};

abstract class _ConfigFailure extends Error {
  public abstract map<R>(callbacks: ConfigFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: ConfigFailureMaybeMap<R>): R;
}

class ServerFailure extends _ConfigFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: ConfigFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: ConfigFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _ConfigFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: ConfigFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: ConfigFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

export type ConfigFailure = ServerFailure | NetworkFailure;

export const ConfigFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
};
